<template>
  <UiInputTextAreaVeeBase v-bind="{ ...$props, ...$attrs }" />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { TValidationRules } from '@team-milva/lab-components'

export default {
  name: 'UiInputTextAreaVee',
  inheritAttrs: false,
  props: {
    name: { type: String, required: true as const },
    label: { type: String, default: undefined },
    rules: { type: Array as PropType<TValidationRules[]>, default: undefined },
    modelValue: { type: String, required: true as const },
    type: { type: String, default: undefined },
    placeholder: { type: String, default: undefined },
    maxLength: { type: Number, default: undefined },
    showAsRequired: { type: Boolean, default: undefined },
    isRequired: { type: Boolean, default: undefined },
    isDisabled: { type: Boolean, default: undefined },
    submitOnCtrlEnter: { type: Boolean, default: undefined },
  },
}
</script>

